import React from 'react'

const DidTakeFurtherBorrowing = ({
    onSelectAnswer,
    backClick,
    setStrugleRepaymentsBck }) => {

    const optionHandle = async (e) => {
        setStrugleRepaymentsBck(e.target.value);
        if (e.target.value === "312") {
            onSelectAnswer(e);
        } else if (e.target.value === "313") {
            onSelectAnswer(e);
        }

    }
  return (
    <div className="question-content mt-0 scale-down-ver-center px-3 py-lg-3 py-md-3 py-sm-2 py-2 ">
    <div className="row">
        <div className="col-6">
            <div className=" mb-2">
                <button
                    type="button"
                    className={`btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn`}
                    onClick={optionHandle}
                    value="312"
                    name="didtakefurtherborrowing"
                    id="nextscroll"
                    data-quest-id={111}
                    data-ans-id={312}
                    data-ans-label={null}
                >Yes
                </button>
            </div>
        </div>
        <div className="col-6">
            <div className=" mb-2">
                <button
                    type="button"
                    className={`btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 noissue`}
                    onClick={optionHandle}
                    value="313"
                    name="didtakefurtherborrowing"
                    id="nextscroll"
                    data-quest-id={111}
                    data-ans-id={313}
                    data-ans-label={null}
                >No
                </button>
            </div>
        </div>
    </div>
    <p className="text-center bck-marwid">
        <button
            name="incmAndexp"
            className="btn btn-secondary backbtn1a"
            id=""
            value=""
            type="button"
            onClick={backClick}
        >
            Go Back
        </button>
    </p>
</div>
  )
}

export default DidTakeFurtherBorrowing;